export enum TourStepMediaType {
  IMAGE = 'image',
  LOTTIE = 'lottie',
  VIDEO = 'video',
  SVG = 'svg',
}
